export default {
  time_options: {
    asap: {
      title: 'Hurtigst muligt',
      description: 'Klar om {{time}} min.',
    },
    scheduled: {
      title: 'Planlæg til senere',
    },
  },
};
